import * as React from 'react';
import { Label as LabelPrimitive } from '@/features/ui/primitives/label';
import { cn } from '@/lib/utils';

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive>
>(({ className, ...props }, ref) => (
  <LabelPrimitive ref={ref} className={cn(className)} {...props} />
));
Label.displayName = 'Label';

export { Label };
